module.exports = __webpack_public_path__ + "media/video.933989bd.mp4";